<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu
      top
      v-bind:flip="flip"
      v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <svg
            v-if="!isDeleted"
            class="tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 181">
            <path
              d="M30.3205 132.969C29.4319 129.582 28.8331 118.12 28.6448 112.811L43.3862 110.896C43.2719 119.732 42.8817 140.81 42.2355 154.436C41.5892 168.063 37.7253 176.643 35.8741 179.23C35.5711 179.767 34.7432 180.318 33.8546 178.222C32.7439 175.601 32.239 165.422 32.138 158.468C32.037 151.513 31.4312 137.202 30.3205 132.969Z"
              v-bind:class="{ selected: isSelected('root_1') }"
              v-bind:fill="partColor['root_1'] || '#FFF'"
              v-on:click="onClick('root_1', $event)"
              v-on:keydown="onClick('root_1', $event)" />
            <path
              d="M39.5879 127.616L39.6106 127.667C39.7676 128.02 39.8181 128.41 39.7595 128.792C37.911 140.83 38.3135 155.763 37.9274 159.512C37.8926 159.85 37.7291 160.149 37.4891 160.39C37.2504 160.629 36.9054 160.793 36.6259 160.602C36.3651 160.425 36.0899 160.05 36.0481 159.262C35.464 148.24 34.6181 134.972 33.1604 128.805L33.0149 128.15C32.9438 127.83 33.0065 127.494 33.1885 127.221C33.3369 126.999 33.5554 126.832 33.8093 126.747L34.1884 126.621L35.0878 126.492L36.9251 126.442L38.014 126.551C38.1444 126.564 38.2737 126.587 38.4008 126.618C38.929 126.751 39.3669 127.119 39.5879 127.616Z"
              v-bind:class="{ selected: isSelected('central_canal') }"
              v-bind:fill="partColor['central_canal'] || '#FF82BE'"
              v-on:click="onClick('central_canal', $event)"
              v-on:keydown="onClick('central_canal', $event)" />
            <path
              d="M43.2447 85.6994L29.9118 85.6037C29.4446 85.6003 28.9783 85.6447 28.5202 85.7362C28.3066 85.7788 28.0947 85.8349 27.9108 85.9514C27.5405 86.186 26.8897 86.7385 26.4163 87.9083C25.9964 88.9459 25.9678 90.0883 25.9841 91.2075C26.0426 95.2189 26.4117 102.458 27.5936 108.981C27.8556 110.427 28.2173 111.698 28.6442 112.811C30.1913 116.844 32.5947 118.804 34.2132 119.509C34.6981 119.721 35.2318 119.765 35.7607 119.765C36.7664 119.765 37.7776 119.569 38.5873 118.972C40.0127 117.922 41.8446 116.014 42.7398 113.214C42.9596 112.527 43.1761 111.74 43.3857 110.896C44.3313 107.087 44.8299 102 45.1606 99.6079C45.1942 96.7523 45.5469 90.638 45.4661 88.6222C45.4205 87.4852 45.1372 86.7437 44.8264 86.2891C44.4866 85.7923 43.8466 85.6994 43.2447 85.6994Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onClick('all', $event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <bottom-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import BottomToothSurface from '../BottomToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    BottomToothSurface,
  },
  mixins: [toothMixin],
  name: 'ToothDown1',
};
</script>

<style scoped>
.tooth {
  flex-direction: column-reverse;
}
.tooth__body {
  grid-template-rows: 30px 25px 78px;
}
.tooth__parts {
  top: auto;
  bottom: 29.28px;
}
</style>
